
import React, { useState } from 'react'
import { MdArrowRight } from 'react-icons/md';
import Popup from '../../../../../common/components/popup';
import FromAddress from '../advance-cargo-booking/fromAddressBook.component';
import ToAddress from '../advance-cargo-booking/toAddressBook.component';

export default function ParcelLocationComponent({ quoteData,
    handleChange,
    selectedToAddressBookId,
    selectedToAddressBook,
    setSelectedToAddressBookId,
    setSelectedToAddressBook,
    selectedFromAddressBookId,
    selectedFromAddressBook,
    setSelectedFromAddressBookId,
    setSelectedFromAddressBook,
    addressbookId,
    addressBook }: any) {

    const [isOpenFromAddressPopup, setIsOpenFromAddressPopup] = useState(false);
    const [isOpenToAddressPopup, setIsOpenToAddressPopup] = useState(false);
    const handleOpenFromAddressPopup = () => {
        setIsOpenFromAddressPopup(true);
    };

    const handleCloseFromAddressPopup = () => {
        setIsOpenFromAddressPopup(false);
    };

    const handleOpenToAddressPopup = () => {
        setIsOpenToAddressPopup(true);
    };

    const handleCloseToAddressPopup = () => {
        setIsOpenToAddressPopup(false);
    };

    return (
        <>
            <div className="w-full font-bold space-y-4">

                {/* Pickup Section */}
                <div className="p-1 w-full">
                    <div className="font-semibold text-base text-slate-800 min-h-[1.5rem]">Pickup Address Details <span className="text-red-500">*</span></div>
                    <div className="relative group mt-1">
                        <div className="w-full border border-gray-300 font-normal rounded-md px-4 py-3 bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500 shadow-sm transition-all">
                            <div className="items-center mb-1">
                                <h5 className="text-base font-semibold text-gray-900 capitalize">
                                    {`${selectedFromAddressBook?.FirstName}, ${selectedFromAddressBook?.LastName}`}
                                </h5>
                            </div>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                {`${selectedFromAddressBook?.Address1}, ${selectedFromAddressBook?.Address2}, `}
                                {`${selectedFromAddressBook?.City}, ${selectedFromAddressBook?.StateProvince?.Name}, `}
                                {`${selectedFromAddressBook?.ZipPostalCode}.`}
                            </p>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                {`Phone no: ${selectedFromAddressBook?.PhoneNumber}`}
                            </p>
                            <div className="flex justify-end mt-4">
                                <div
                                    onClick={handleOpenFromAddressPopup}
                                    className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-950 cursor-pointer"
                                >
                                    Change the pickup address
                                    <MdArrowRight className="text-base ml-1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Pickup Address Additional Info */}
                <div className="w-full">
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">
                        Additional Info
                    </label>
                    <input
                        type="text"
                        name="startBuilding"
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => handleChange(event.target.value, 'startBuilding')}
                        value={quoteData?.startBuilding}
                    />
                </div>

                {/* Drop Section */}
                <div className="p-1 w-full">
                    <div className="font-semibold text-base text-slate-800 min-h-[1.5rem]">Drop Address Details <span className="text-red-500">*</span></div>
                    <div className="relative group mt-1">
                        <div className="w-full border border-gray-300 font-normal rounded-md px-4 py-3 bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500 shadow-sm transition-all">
                            <div className="flex items-center justify-between mb-1">
                                <h5 className="text-base font-semibold text-gray-900 capitalize">
                                    {`${selectedToAddressBook?.FirstName}, ${selectedToAddressBook?.LastName}`}
                                </h5>

                            </div>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                {`${selectedToAddressBook?.Address1}, ${selectedToAddressBook?.Address2}, `}
                                {`${selectedToAddressBook?.City}, ${selectedToAddressBook?.StateProvince?.Name}, `}
                                {`${selectedToAddressBook?.ZipPostalCode}.`}
                            </p>
                            <p className="text-sm text-gray-700 leading-relaxed">
                                {`Phone no: ${selectedToAddressBook?.PhoneNumber}`}
                            </p>
                            <div className="flex justify-end mt-4">
                                <div
                                    onClick={handleOpenToAddressPopup}
                                    className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-950 cursor-pointer"
                                >
                                    Change the drop address
                                    <MdArrowRight className="text-base" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Drop Address Additional Info */}
                <div className="w-full">
                    <label className="font-semibold line-clamp-2 mb-2 text-slate-800 ">
                        Additional Info
                    </label>
                    <input
                        type="text"
                        name="endBuilding"
                        className="w-full border font-normal rounded-md px-4 py-2  bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500"
                        onChange={(event: any) => handleChange(event.target.value, 'endBuilding')}
                        value={quoteData?.endBuilding}
                    />
                </div>
            </div>
            {isOpenFromAddressPopup && (
                <Popup onClose={handleCloseFromAddressPopup}>
                    <h2 className="text-2xl font-bold mb-4">Manage From Address</h2>
                    <FromAddress
                        addressBook={addressBook}
                        addressbookId={addressbookId}
                        selectedFromAddressBookId={selectedFromAddressBookId}
                        setSelectedFromAddressBookId={setSelectedFromAddressBookId}
                        selectedFromAddressBook={selectedFromAddressBook}
                        setSelectedFromAddressBook={setSelectedFromAddressBook}
                        onClose={handleCloseFromAddressPopup}
                    />
                </Popup>
            )}
            {isOpenToAddressPopup && (
                <Popup onClose={handleCloseToAddressPopup}>
                    <h2 className="text-2xl font-bold mb-4">Manage To Address</h2>
                    <ToAddress
                        addressBook={addressBook}
                        addressbookId={addressbookId}
                        selectedToAddressBookId={selectedToAddressBookId}
                        setSelectedToAddressBookId={setSelectedToAddressBookId}
                        selectedToAddressBook={selectedToAddressBook}
                        setSelectedToAddressBook={setSelectedToAddressBook}
                        onClose={handleCloseToAddressPopup}
                    />
                </Popup>
            )}</>

    )
}